import { Box, Typography, IconButton, styled, alpha } from '../../base';

export const StyledFileItem = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: alpha(theme.palette.info.main, 0.05),
}));

export const StyledFileIconContainer = styled(Box)(({ theme }) => ({
    width: 40,
    height: 40,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.info.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const StyledFileName = styled(Typography)(({ theme }) => ({
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));

export const StyledFileSize = styled(Typography)(({ theme }) => ({
    fontSize: 10,
    color: theme.palette.text.secondary,
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    padding: theme.spacing(0.5),
    color: theme.palette.grey[600],
    width: 25,
    height: 25,
}));
